import { map, catchError } from 'rxjs/operators';
import { DateService } from '@core/services';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { QueryOptions, Message, Updated } from '@models/system';
import { type HttpService } from '@http/services';
import { OrderProduct } from '@models/domain';

@Injectable({
    providedIn: 'root'
})
export class OrderProductService implements HttpService<OrderProduct> {

    constructor(private http: HttpClient) {}

    fetch(qo: QueryOptions) : Observable<HttpResponse<OrderProduct[]>> {
        return this.http.get<OrderProduct[]>(env.API_URL + '/orders-products', {
            params: qo.toObject(), // { offset: qo.offset, limit: qo.limit, eq: qo.eq, dig: qo.dig}, 
            observe: 'response'
        });
    }

    get(id: string[]) : Observable<HttpResponse<OrderProduct>> {
        return this.http.get<OrderProduct>(env.API_URL + '/orders-products/' + id[0] + '/' + id[1], {
            params: {},
            observe: 'response'
        }).pipe(
            map( resp => {
                if (resp.body != null && resp.body.product_id) {
                    resp.body.datetime = DateService.toDateString(resp.body.datetime);
                }
                return resp;
            })
        );
    }

    post(t: OrderProduct): Observable<HttpResponse<OrderProduct>> {
        //return throwError(() => new Error("Invalid API service call attempt"));
        return this.http.post<OrderProduct>(env.API_URL + '/orders-products', t, {
            params: {},
            observe: 'response'
        });
    }

    put(t: OrderProduct): Observable<HttpResponse<Message>> { 
        return throwError(() => new Error("Invalid API service call attempt"));
    }

    delete(id: string[]) : Observable<HttpResponse<Message>> {
        //return throwError(() => new Error("Invalid API service call attempt"));
        return this.http.delete<Message>(env.API_URL + '/orders-products/' + id[0] + '/' + id[1], {
            params: {},
            observe: 'response'
        });
    }

}
